import { unitAt } from "@dailywars/core/engine";
import type { Coord, GameState, Unit } from "@dailywars/core/engine";

import { isOwnSelectableUnit } from "#/game/selection/transitions";
import type { StoreState } from "#/game/store/types";

export interface TileSelectContext {
  state: StoreState;
  local: GameState;
  tile: Coord;
  clickedUnit: Unit | undefined;
  clickedOwnSelectable: Unit | undefined;
}

export function canAcceptTileSelect(state: StoreState): boolean {
  if (state.animation) return false;
  if (state.isSubmitting) return false;
  if (state.localState.currentPlayer !== "p1") return false;
  if (state.localState.status !== "in_progress") return false;
  return true;
}

export function makeTileSelectContext(state: StoreState, tile: Coord): TileSelectContext {
  const local = state.localState;
  const clickedUnit = unitAt(local, tile);
  const clickedOwnSelectable = isOwnSelectableUnit(local, clickedUnit) ? clickedUnit : undefined;
  return { state, local, tile, clickedUnit, clickedOwnSelectable };
}
